import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom'; // Use react-router-dom for routing


const BlogDetailsMain = () => {


      const { slug } = useParams(); 
      const [post, setPost] = useState(null);
      const [loading, setLoading] = useState(true);
      const [subcategories, setSubcategories] = useState([]);
      const [loadingSubcats, setLoadingSubcats] = useState(true);
      const [recentPosts, setRecentPosts] = useState([]);
      const [tags, setTags] = useState([]);
      const [prevPost, setPrevPost] = useState(null);
      const [nextPost, setNextPost] = useState(null);


      useEffect(() => {
        fetch(`https://rsvpevents.local/wp-json/wp/v2/posts?slug=${slug}&_embed`)
          .then((res) => res.json())
          .then(async (data) => {
            if (data.length > 0) {
              const postData = data[0];
              setPost(postData);

              if (postData.tags && postData.tags.length > 0) {
                const tagIDs = postData.tags.join(',');
                const tagRes = await fetch(`https://rsvpevents.local/wp-json/wp/v2/tags?include=${tagIDs}`);
                const tagData = await tagRes.json();
                setTags(tagData);
              } else {
                setTags([]);
              }
            } else {
              setPost(null);
            }

        setLoading(false);
      })
      .catch((err) => {
        console.error('Error fetching post:', err);
        setLoading(false);
      });
  }, [slug]);

     
        // ✅ Fetch Blog subcategories once
      useEffect(() => {
        async function fetchSubcategories() {
          try {
            const res = await fetch(`https://rsvpevents.local/wp-json/wp/v2/categories?slug=blog`);
            const data = await res.json();

            if (data.length === 0) throw new Error('Blog category not found');
            const blogCategoryId = data[0].id;

            const subcatRes = await fetch(`https://rsvpevents.local/wp-json/wp/v2/categories?parent=${blogCategoryId}`);
            const subcatData = await subcatRes.json();

            setSubcategories(subcatData);
          } catch (err) {
            console.error('Error fetching subcategories:', err);
          } finally {
            setLoadingSubcats(false);
          }
        }

        fetchSubcategories();
      }, []);


      //// get recents posts
      useEffect(() => {
        fetch(`https://rsvpevents.local/wp-json/wp/v2/posts?categories=82&per_page=6&_embed`)
          .then((res) => res.json())
          .then((data) => {
            // Filter out the post with the current slug
            const filtered = data.filter((post) => post.slug !== slug);
            // Keep only 5 recent (after removing current post)
            setRecentPosts(filtered.slice(0, 5));
            setLoading(false);
          })
          .catch((err) => {
            console.error('Error fetching blog posts:', err);
            setLoading(false);
          });
      }, [slug]);

      useEffect(() => {
          fetch(`https://rsvpevents.local/wp-json/wp/v2/posts?categories=82&per_page=100&_fields=slug,title`)
            .then(res => res.json())
            .then(data => {
              const index = data.findIndex(post => post.slug === slug);
              if (index !== -1) {
                setPrevPost(data[index - 1] || null);
                setNextPost(data[index + 1] || null);
              }
            })
            .catch(err => console.error('Error fetching posts:', err));
        }, [slug]);

      
      if (loading) return <p>Loading...</p>;
      if (!post) return <p>Post not found.</p>;

      const featuredImage = post._embedded?.['wp:featuredmedia']?.[0]?.source_url;
      const tagsNames = tags.map(t => t.name);
      const categories = subcategories.map(cat => ({ "@type": "CategoryCode", "name": cat.name }));

        const jsonLd = {
          "@context": "https://schema.org",
          "@type": "BlogPosting",
          "headline": post.title.rendered.replace(/<\/?[^>]+(>|$)/g, ""), 
          "image": featuredImage || undefined,
          "datePublished": post.date,
          "articleBody": post.content.rendered.replace(/<\/?[^>]+(>|$)/g, ""), 
          "mainEntityOfPage": {
            "@type": "WebPage",
            "@id": window.location.href
          },
          "publisher": {
            "@type": "Organization",
            "name": "RSVPPASS",
            "logo": {
              "@type": "ImageObject",
              "url": "https://rsvppass.com/rsvp_logo.png" 
            }
          },
          "keywords": tagsNames,
          "about": categories,
          "relatedLink": [
            prevPost
              ? {
                  "@type": "BlogPosting",
                  "headline": prevPost.title || "Previous Post",
                  "url": `${window.location.origin}/event-news-details/${prevPost.slug}`
                }
              : undefined,
            nextPost
              ? {
                  "@type": "BlogPosting",
                  "headline": nextPost.title || "Next Post",
                  "url": `${window.location.origin}/event-news-details/${nextPost.slug}`
                }
              : undefined
          ].filter(Boolean)
        };

    return (
        <React.Fragment>
         
         <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
          />
       
            {/* Blog Details Start */}
            <section className="blog-details">
          <div className="container">
            <div className="row">
              <div className="col-xl-8 col-lg-7">
                <div className="blog-details__left">
                  <div className="blog-details__img-1">
                    {featuredImage && <img src={featuredImage} alt="Featured" />}
                    {/* <div className="blog-details__date">
                      <p>22 Jan</p>
                    </div> */}
                  </div>
                  <div className="blog-details__content">
                    <h3 className="blog-details__title-1" dangerouslySetInnerHTML={{ __html: post.title.rendered }} ></h3>
                    <p className="event-details__text-1" dangerouslySetInnerHTML={{ __html: post.content.rendered }}></p>
                  
                  
                     <div className="blog-details__prev-and-next">
                        <div className="blog-details__prev-box">
                          {prevPost && (
                            <>
                              <Link to={`/event-news-details/${prevPost.slug}`} className="blog-details__prev-arrow">
                                <span className="icon-arrow-left"></span>
                              </Link>
                              <Link to={`/event-news-details/${prevPost.slug}`} className="blog-details__prev">
                                Previous
                                <br /> post
                              </Link>
                            </>
                          )}
                        </div>
                        <div className="blog-details__next-box">
                          {nextPost && (
                            <>
                              <Link to={`/event-news-details/${nextPost.slug}`} className="blog-details__next">
                                Next
                                <br /> post
                              </Link>
                              <Link to={`/event-news-details/${nextPost.slug}`} className="blog-details__next-arrow">
                                <span className="icon-arrow-right"></span>
                              </Link>
                            </>
                          )}
                        </div>
                      </div>
                  
                  </div>
                 
                </div>
              </div>
              {/* Sidebar */}
              <div className="col-xl-4 col-lg-5">
                <div className="sidebar">
               

                  {/* Categories */}
                  <div className="sidebar__single sidebar__all-category">
                    <h3 className="sidebar__title">Category</h3>
                    <ul className="sidebar__all-category-list list-unstyled">
                      {subcategories.map((category, index) => (
                        <li
                          key={index}
                          className={category.active ? "active" : ""}
                        >
                          <Link to={`/event-news/${category.slug}`}>
                            <i className="icon-double-angle"></i>
                            {category.name}
                            <span>({category.count})</span>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Recent Posts */}
                  <div className="sidebar__single sidebar__post">
                    <h3 className="sidebar__title">Recent Post</h3>
                    <ul className="sidebar__post-list list-unstyled">
                      {recentPosts.map((post, index) => (
                        <li key={post.id}>
                          <div className="sidebar__post-content">
                            <p className="sidebar__post-date">
                              <span className="icon-calendar"></span>
                              {post.date}
                            </p>
                            <h3>
                              <Link to={`/event-news-details/${post.slug}`}>{post.title.rendered}</Link>
                            </h3>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Tags */}
                  <div className="sidebar__single sidebar__tags">
                    <h3 className="sidebar__title">Tags</h3>
                    <div className="sidebar__tags-list">
                      {tags.map((tag) => (
                        <Link to="" key={tag.id}>
                          {tag.name}
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
                    {/* Blog Details End */}
        </React.Fragment>
    );
};

export default BlogDetailsMain;
